var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { PeekBox, PeekInputSelect, useTheme } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export var AccessDetailOption;
(function (AccessDetailOption) {
    AccessDetailOption["LEASING"] = "leasing_office";
    AccessDetailOption["OTHER"] = "other";
})(AccessDetailOption || (AccessDetailOption = {}));
export const AccessDetailsSelector = (_a) => {
    var props = __rest(_a, []);
    const intl = useIntl();
    const theme = useTheme();
    const selectItems = useMemo(() => [
        { id: AccessDetailOption.LEASING, name: intl.formatMessage(messages.leasingOfficeOption) },
        { id: AccessDetailOption.OTHER, name: intl.formatMessage(messages.otherOption) },
    ], []);
    return (React.createElement(PeekBox, { mb: props.form.values.accessDetails === AccessDetailOption.OTHER && theme.spacing(-1.5) },
        React.createElement(PeekInputSelect, Object.assign({}, props, { items: selectItems }))));
};
export default AccessDetailsSelector;
